__turbopack_context__.v({
  "mediaContainer": "RichText-module-scss-module__OShTVG__mediaContainer",
  "richText": "RichText-module-scss-module__OShTVG__richText",
});
